import { PointTransition } from '../components/XYChart/hooks/useCustomPointTransition';

export const createSinglePathSegmentTransition = (
  firstPoint: PointTransition,
  secondPoint: PointTransition,
  startNewSegment = false,
): [initialPathSegment: string, transitionPathSegment: string] => {
  let initialPathSegment = '';
  let transitionPathSegment = '';

  if (startNewSegment) {
    initialPathSegment += 'M';
    transitionPathSegment += 'M';
  } else {
    initialPathSegment += 'L';
    transitionPathSegment += 'L';
  }
  if (
    (firstPoint.to.value === undefined && firstPoint.from.value !== undefined) ||
    (secondPoint.to.value === undefined && secondPoint.from.value !== undefined)
  ) {
    // this segment is being dropped
    const emptyPoint = firstPoint.to.value === undefined ? firstPoint : secondPoint;
    initialPathSegment += `${firstPoint.from.cx},${firstPoint.from.cy}L${secondPoint.from.cx},${secondPoint.from.cy}`;
    transitionPathSegment += `${firstPoint.to.cx},${emptyPoint.to.cy}L${secondPoint.to.cx},${emptyPoint.to.cy}`;
  } else if (
    (firstPoint.to.value !== undefined && firstPoint.from.value === undefined) ||
    (secondPoint.to.value !== undefined && secondPoint.from.value === undefined)
  ) {
    // this segment is being added
    const emptyPoint = firstPoint.from.value === undefined ? firstPoint : secondPoint;
    initialPathSegment += `${firstPoint.from.cx},${emptyPoint.from.cy}L${secondPoint.from.cx},${emptyPoint.from.cy}`;
    transitionPathSegment += `${firstPoint.to.cx},${firstPoint.to.cy}L${secondPoint.to.cx},${secondPoint.to.cy}`;
  } else {
    // number of points for this segment has not changed
    initialPathSegment += `${firstPoint.from.cx},${firstPoint.from.cy}L${secondPoint.from.cx},${secondPoint.from.cy}`;
    transitionPathSegment += `${firstPoint.to.cx},${firstPoint.to.cy}L${secondPoint.to.cx},${secondPoint.to.cy}`;
  }
  return [initialPathSegment, transitionPathSegment];
};
